require ('jquery');

// Import custom web js controls for 
// dark mode color and sidebar toggle
import './app.color-modes';
import './app.sidebar.toggle';

// Import website logo images
import '../images/logo.png';
import '../images/logo-light.png';

import '../images/logo-text.png';
import '../images/logo-text-light.png';

import '../images/brand-bg-dark.jpg';
import '../images/brand-bg-light.jpg';

import '../images/trickle-drk.jpg';
import '../images/brand-stock-photo.jpg';

(() => {
    'use strict';
    document.addEventListener('DOMContentLoaded', function() {
        const navbar = document.getElementById('navbar-scroll-update');
        const triggerDiv = document.getElementById('navbar-scroll-trigger');

        if(navbar != null && triggerDiv != null){
            // Function to check scroll position and update navbar
            function updateNavbar() {
                // Get the trigger div's position relative to the viewport
                const triggerPosition = triggerDiv.getBoundingClientRect().top;
                //console.log('Trigger position:', triggerPosition); // Debugging line
                // If trigger div is scrolled past (top edge is above viewport)
                if (triggerPosition < -300) {
                    navbar.classList.add('bg-black'); // Add colored class
                    navbar.classList.remove('py-4');
                } else {
                    navbar.classList.remove('bg-black'); // Remove colored class
                    navbar.classList.add('py-4');
                }
            }
            
            // Run on initial load (in case user refreshes mid-scroll)
            updateNavbar();
            
            // Run on scroll
            window.addEventListener('scroll', updateNavbar);
            
            // Optional: Run on window resize (in case viewport size changes)
            window.addEventListener('resize', updateNavbar);
        }
        
    });
})();